import "./footerStyle.css"

export const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center space-y-6">
          <div className="text-3xl md:text-4xl font-bold text-orange-400 mb-4">幸の鶏</div>

          <div className="grid md:grid-cols-2 gap-6 text-left md:text-center">
            <div className="space-y-3">
              <div className="flex items-center justify-center md:justify-center gap-2">
                <svg className="w-5 h-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                <span className="font-semibold">電話:</span>
                <a href="tel:0995-47-5013" className="text-orange-400 hover:text-orange-300 font-bold text-lg">
                  0995-47-5013
                </a>
              </div>

              <div className="flex items-start justify-center md:justify-center gap-2">
                <svg
                  className="w-5 h-5 text-orange-400 mt-1 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <polyline points="12,6 12,12 16,14"></polyline>
                </svg>
                <div>
                  <div className="font-semibold">営業時間:</div>
                  <div>11:00 〜 14:00　16:00 〜 19:30</div>
                  <div className="text-sm text-gray-300">電話のラストオーダーは19:00まで</div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center md:justify-center gap-2">
              <svg
                className="w-5 h-5 text-orange-400 flex-shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <div>
                <div className="font-semibold">定休日:</div>
                <div>毎週火曜日、第2・3水曜日</div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-6 mt-8">
            <p className="text-gray-400 text-sm">© 2021 tsuchiya39</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
